"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollToTop = ScrollToTop;
const react_1 = __importStar(require("react"));
require("bootstrap/dist/css/bootstrap.min.css");
require("react-responsive-carousel/lib/styles/carousel.min.css");
require("react-quill/dist/quill.snow.css");
require("react-bootstrap-table-next/dist/react-bootstrap-table2.min.css");
require("react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css");
require("react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css");
require("react-medium-image-zoom/dist/styles.css");
const react_router_dom_1 = require("react-router-dom");
const hook_1 = require("../redux/hook");
const Secure_1 = __importDefault(require("../modules/Secure/Secure"));
const react_hot_toast_1 = __importStar(require("react-hot-toast"));
const router_1 = require("../modules/routes/router");
const User_slice_1 = require("../redux/slice/User.slice");
const constante_1 = require("../utils/constante");
const Loader_1 = __importDefault(require("./Shared/Loader"));
const RemorquageNotifications_1 = __importDefault(require("./Admin/RemorquageNotifications/RemorquageNotifications"));
const NotificationsRealtime_1 = __importDefault(require("./Admin/StaffSocketNotification/NotificationsRealtime"));
function ScrollToTop() {
    const { pathname } = (0, react_router_dom_1.useLocation)();
    (0, react_1.useEffect)(() => {
        const scrollToTop = () => {
            try {
                // Méthode moderne avec smooth scroll
                window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
            }
            catch (e) {
                // Fallback pour les anciens navigateurs
                const timer = setInterval(() => {
                    const currentPosition = window.pageYOffset ||
                        document.documentElement.scrollTop;
                    if (currentPosition > 0) {
                        window.scrollBy(0, -Math.max(1, Math.floor(currentPosition / 10)));
                    }
                    else {
                        clearInterval(timer);
                    }
                }, 20);
            }
        };
        const timer = setTimeout(scrollToTop, 150);
        return () => clearTimeout(timer);
    }, [pathname]);
    return null;
}
// type RemorquageNotification = {
//     id: number;
//     phone: string;
//     request_datetime: string;
//     lat: string;
//     long: string;
// };
const App = () => {
    // const { message } = useWebSocket(`wss://${window.location.host}/ws`);
    // const socket = useSocket();
    let location = (0, react_router_dom_1.useLocation)();
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, hook_1.useAppDispatch)();
    (0, react_1.useEffect)(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, [location]);
    const routes = (0, react_router_dom_1.useRoutes)(router_1.AppRoutes);
    (0, react_1.useEffect)(() => {
        setTimeout(() => {
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        }, 150);
    }, [pathname]);
    (0, react_1.useEffect)(() => {
        const sessionData = window.sessionStorage.getItem("user");
        const parsed = sessionData ? JSON.parse(sessionData) : null;
        const token = parsed === null || parsed === void 0 ? void 0 : parsed.token;
        const isPublicRoute = constante_1.publicRoutes.some((route) => (0, react_router_dom_1.matchPath)({ path: route, end: true }, pathname));
        const isExpiredToken = (0, Secure_1.default)(token);
        if (token && isExpiredToken && !isPublicRoute) {
            react_hot_toast_1.default.error("Votre session est expirée. Veuillez vous reconnecter.", {
                duration: 5000,
                position: "top-center",
            });
            window.sessionStorage.clear();
            dispatch((0, User_slice_1.onlogout)());
            navigate("/");
        }
    }, [pathname, dispatch, navigate]);
    return (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loader_1.default, null) },
        react_1.default.createElement("div", { className: "router-container" },
            react_1.default.createElement(RemorquageNotifications_1.default, null),
            react_1.default.createElement(NotificationsRealtime_1.default, null),
            react_1.default.createElement(ScrollToTop, null),
            routes,
            react_1.default.createElement(react_hot_toast_1.Toaster, null))));
};
exports.default = App;
